/** Tipografías disponibles en el editor de marca y de landings. */
export const FONT_OPTIONS = [
  { value: 'Inter', label: 'Inter' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Manrope', label: 'Manrope' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'DM Sans', label: 'DM Sans' },
  { value: 'Outfit', label: 'Outfit' },
  { value: 'Plus Jakarta Sans', label: 'Plus Jakarta Sans' },
]

export const FONT_WEIGHTS = [
  { value: '400', label: 'Normal' },
  { value: '500', label: 'Medio' },
  { value: '600', label: 'Semibold' },
  { value: '700', label: 'Negrita' },
]

export const BUTTON_ICONS = [
  { value: '', label: 'Sin icono' },
  { value: 'ArrowRight', label: 'Flecha' },
  { value: 'Sparkles', label: 'Destello' },
  { value: 'Send', label: 'Enviar' },
  { value: 'Calendar', label: 'Calendario' },
  { value: 'MessageCircle', label: 'Mensaje' },
  { value: 'Phone', label: 'Teléfono' },
]
